import { createTheme } from "@material-ui/core";

const theme = createTheme({
  palette: {
    primary: {
      main: "#00f69e",
    },
    secondary: {
      main: "#0000ff",
    },
  },
  overrides: {
    MuiSlider: {
      thumb: {
        width: 43,
        height: 21,
        borderRadius: "10px",
        backgroundColor: "#2EEFAA",
        marginTop: -9,
        marginLeft: -20,
      },
    },
  },
});

export default theme;
